import type { NotificationType } from '@/types/models';

const notificationTypeEnumMap = {
    NEW_MEMBER_JOINED: 1,
    TRANSACTIONS_EXPORT_READY: 2,
    APPROVAL_RULE_UPDATED: 3,
    OUTGOING_TRANSFER_SUCCESSFUL: 4,
    FOODICS_PAY_DAILY_SUMMARY: 5,
    INCOMING_TRANSFER: 6,
    SADAD_BILL_PAID: 7,
    COLLECTION_SUCCESSFUL: 8,
} as const;

export type NotificationTypeEnumKeys = keyof typeof notificationTypeEnumMap;
export type NotificationTypeEnumValues =
    (typeof notificationTypeEnumMap)[NotificationTypeEnumKeys];

export const notificationTypeEnum: NotificationType extends NotificationTypeEnumValues
    ? typeof notificationTypeEnumMap
    : never = notificationTypeEnumMap;

export const notificationTypeKeyMap = Object.fromEntries(
    Object.entries(notificationTypeEnumMap).map(([key, value]) => [value, key]),
) as Record<NotificationTypeEnumValues, NotificationTypeEnumKeys>;
